import { IErrorMessage } from '@hooks/use-error-message.ts';

export const productsErrorMessages: IErrorMessage = {
  name: {
    required: 'validation_name_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  price: {
    required: 'validation_price_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  inventories: {
    required: 'validation_category_required'
  },
  departmentUnit: {
    required: 'validation_department_unit_required'
  },
  description: {
    required: 'validation_description_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  }
};

export const convertToSelectedCategory = (
  data: any
): { id: number; title: string; value: string }[] => {
  if (!data || !data.category) return [];

  const { id, name } = data.category;

  return [
    {
      id,
      title: name,
      value: name
    }
  ];
};

export const convertToSelectedDepartmentUnit = (
  data: any | null
): { id: number; title: string; value: string; type?: string }[] => {
  if (!data || !data.departmentUnit) return [];

  const { id, name, type } = data.departmentUnit;

  return [
    {
      id,
      title: name,
      value: name,
      type
    }
  ];
};
